import { render, staticRenderFns } from "./agents.vue?vue&type=template&id=b6d4bb38&scoped=true&"
import script from "./agents.vue?vue&type=script&lang=js&"
export * from "./agents.vue?vue&type=script&lang=js&"
import style1 from "./agents.vue?vue&type=style&index=1&id=b6d4bb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d4bb38",
  null
  
)

export default component.exports